/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useState } from 'react';
// import { NotificationManager } from 'react-notifications';
import { validateEmail } from '../../utils/auth-utils';
// import { VisibilityIcon, VisibilityOffIcon } from '../../assets/icons';
import { InboundContext } from '../../context/InboundContext';
import { Button, Heading, Text } from '../../components/styledComponents';
import { FormGroup, Logo } from '../../components/common';
import styles from '../../styles/forgotPassword.module.css';
import { forgotPassword, resendForgotPasswordEmail } from '../../services/dashboard.service';
import BackArrowIcon from '../../assets/icons/BackArrowIcon';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [resentEmail, setResentEmail] = useState(false);
  const { inboundData } = useContext(InboundContext);

  const handleForgotPassword = async (e: any) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setErrorMessage('Invalid Email');
    } else {
      const body = { email };
      setDisableSubmitButton(true);
      const response = await forgotPassword(body);
      if (response.status) {
        setEmailSent(true);
      } else {
        setErrorMessage('Invalid Credentials');
      }
    }
    setDisableSubmitButton(false);
  };

  const handleResendEmail = async (e: any) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setErrorMessage('Invalid Email');
    } else {
      const body = { email };
      setDisableSubmitButton(true);
      const response = await resendForgotPasswordEmail(body);
      if (response.status) {
        setResentEmail(true);
      } else {
        setErrorMessage('Invalid Credentials');
      }
    }
  };

  return (
    <div className={styles.forgetPasswordMainDiv}>
      <div className={styles.forgotPasswordForm}>
        {inboundData?.landingPage?.images?.logo ? (
          <Logo logoUrl={inboundData?.landingPage?.images?.logo} />
        ) : (
          <Logo logoUrl="https://saral-docs-prod.s3.amazonaws.com/Saral+Black+Logo.svg" />
        )}
        {!emailSent ? (
          <>
            <div>
              <Heading as="h2" fontSize="20px" textAlign="center" className={styles.firstHeading}>
                Forgot Password?
              </Heading>
              <Text textAlign="center" className={styles.secondHeading}>
                No worries, we&#39;ll send you reset Instructions
              </Text>
              <form onSubmit={handleForgotPassword}>
                <FormGroup
                  id="email"
                  name="email"
                  type="email"
                  label="Email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setErrorMessage('');
                  }}
                />
                {errorMessage && (
                  <div className={styles.labelDiv}>
                    <Text color="#e64848">{errorMessage}</Text>
                  </div>
                )}
                <Button bgColor="#7357e9" width="100%" disabled={!email || disableSubmitButton} type="submit">
                  Send Reset Link
                </Button>
              </form>
            </div>
            <a className={styles.backButton} href="/dashboard/login">
              <BackArrowIcon color="#667085" />
            </a>
          </>
        ) : (
          <>
            <div>
              <Heading as="h2" fontSize="20px" textAlign="center" className={styles.firstHeading}>
                Check your email
              </Heading>
              <Text textAlign="center" className={styles.secondHeading}>
                We sent a password reset link to {email}
              </Text>
              <Button
                bgColor="white"
                color="#7357e9"
                border="1px solid #7357e9"
                width="100%"
                className={styles.actionButton}
                disabled={!email || resentEmail}
                type="submit"
                onClick={(e) => {
                  handleResendEmail(e);
                }}
              >
                Resend Email
              </Button>
            </div>
            <a href="/dashboard/login" className={styles.backButton}>
              <BackArrowIcon color="#667085" /> Back to Login
            </a>
          </>
        )}
      </div>
    </div>
  );
}
